import React, { Component } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import IconBox from '../../components/IconBox';
import Faciality from '../../components/Faciality';
import TestimonialSlider from '../../components/TestimonialSlider';
import FaqEvent from '../../components/FaqEvent';
import Footer from '../../components/Footer';
import { Styles } from "./styles/facilities";

class Facilities extends Component {

    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper facilities-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Facilities" />

                    {/* About Area */}
                    {/* <AboutUs /> */}

                    {/* Icon Box Area */}
                    {/* <IconBox /> */}

                    {/* Tab Section */}
                    <Faciality />

                    {/* Testimonial Slider */}
                    {/* <TestimonialSlider /> */}

                    {/* Faq & Event Area */}
                    {/* <FaqEvent /> */}

                    {/* Footer 2 */}
                    <Footer />

                </div>
            </Styles>
        )
    }
}

export default Facilities